module.exports = __webpack_public_path__ + "static/media/kunkka.009e1e96.png";